<template>
  <router-view></router-view>
</template>
<script type="text/javascript">
export default {
  name: 'Provider'
}

</script>



// WEBPACK FOOTER //
// src/Osm/Provider/containers/Provider.vue